import axios from '../getAxios';
import { signUpPayloadProps } from '../types';

export default async (payload: signUpPayloadProps) => {

  const { data } = await axios({
    method: 'POST',
    url: '/api/customer/sign-up',
    data: payload,
  });
  return data;
};
